module.exports = __webpack_public_path__ + "static/media/launchedStudy.c84cd069.svg";